import apiClient from '../config/axios';
import { ENDPOINTS } from '../constants/endpoints';

export const dashboardService = {
  // Get dashboard header stats
  getHeaderStats: async () => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.ARTICLES}/Header`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get header stats error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des statistiques',
        error: error.response?.data,
      };
    }
  },

  // Get dashboard articles by year for a client
  getDashboardArticles: async (clientId) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.ARTICLES}/DashboardArticle?ClientdId=${clientId}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get dashboard articles error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des articles du dashboard',
        error: error.response?.data,
      };
    }
  },

  // Get last intervention for a local (FIXED: Changed from ClientdId to LocalId)
  getLastIntervention: async (localId) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.ARTICLES}/DashboardLastIntevention?LocalId=${localId}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get last intervention error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement de la dernière intervention',
        error: error.response?.data,
      };
    }
  },
};

export default dashboardService;